import { render } from "./AddressPage.vue?vue&type=template&id=09ba6b25&scoped=true&ts=true"
import script from "./AddressPage.vue?vue&type=script&lang=ts"
export * from "./AddressPage.vue?vue&type=script&lang=ts"

import "./AddressPage.vue?vue&type=style&index=0&id=09ba6b25&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ba6b25"]])

export default __exports__